<template>
  <li>
    <router-link :to="to" class="cta-link" :class="{ 'cta-link-large': isLarge }">
      <h5 class="card-text">{{ title }}</h5>
    </router-link>
  </li>
</template>
<script>
  export default {
    name: "Button",
    props: {
      title: String,
      to: {
        type: [String, Object],
        required: true
      },
      isLarge: Boolean
    },
    data() {
      return {

      }
    },
    methods: {},
    computed: {

    }
  };
</script>

<style lang="scss" scoped>
  .cta-link {
    font-family: 'Poppins', sans-serif;
    letter-spacing: 2px;
    display: flex;
    width: 200px;
    max-width: 410px;
    color: white;
    border-radius: 50px;
    text-decoration: underline;
    padding: 15px;
    justify-content: space-evenly;
    background: #850A56;
    transition: all 0.3s ease;
    transform: translateY(0);

    &:hover {
      transform: translateY(-5px);
    }

    h5 {
      font-size: 14px;
      transition: color 0.3s ease;
      text-align: center;
    }

    i {
      transition: transform 0.3s ease;
    }

    &:hover i {
      transform: translateX(5px);
    }
  }

  .cta-link-large {
    width: 100%;
  }
</style>